import { ScrollTrigger } from "gsap/ScrollTrigger";

export default class VacancyHeader {
    constructor(elm) {
        this.elm = elm;

        this.stickyApplyButton = this.elm.closest('div').querySelector('[data-sticky-apply-button]');
        this.init();
    }

    init() {

        if(this.stickyApplyButton) {
            ScrollTrigger.create({
                trigger: this.stickyApplyButton,
                start: "top top",
                end: document.documentElement.scrollHeight,
                pin: this.stickyApplyButton,
                pinSpacing: false
            });

            ScrollTrigger.create({
                trigger: this.elm,
                start: "bottom center",
                end: document.documentElement.scrollHeight-(window.innerHeight*2),
                onEnter: () => {
                    this.stickyApplyButton.classList.add('c-sticky-apply-button--visible');
                },
                onEnterBack: () => {
                    this.stickyApplyButton.classList.add('c-sticky-apply-button--visible');
                },
                onLeave: () => {
                    this.stickyApplyButton.classList.remove('c-sticky-apply-button--visible');
                },
                onLeaveBack: () => {
                    this.stickyApplyButton.classList.remove('c-sticky-apply-button--visible');
                }
            });
        }

    }
}